import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    { staticClass: "ml-0" },
    [
      _c(
        VCol,
        { staticClass: "pa-0", attrs: { cols: "6" } },
        [
          _vm.canSeeAlerts && _vm.product.filteredAlerts.length
            ? _c("product-alerts", {
                key: _vm.product._id,
                attrs: { alerts: _vm.product.filteredAlerts },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VCol,
        {
          class: _vm.isAgGridProductListEnabled ? "promotion-col" : "pa-0",
          attrs: { cols: "6" },
        },
        [
          _vm.itemHasUpcomingPromotion(_vm.product)
            ? _c(
                "tooltip",
                {
                  attrs: {
                    value: _vm.getFreezePromotionTooltip(_vm.product),
                    position: _vm.position,
                  },
                },
                [_vm._m(0)],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, [_vm._v(" $promotion-pr ")])
  },
]
render._withStripped = true

export { render, staticRenderFns }